import React from 'react'
import PropertyCreatedLogs from './components/PropertyCreatedLogs'

function AllLogs() {
    return (
        <PropertyCreatedLogs />
    )
}

export default AllLogs
